module.exports = __webpack_public_path__ + "imgs/strain.c3557d746e4fd98c3e6c6f390639c4a7.svg";